import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import { Map } from 'immutable';
import { Link } from 'react-router';
import DropDownButton from '../../ui/DropDownButton';
import GetStartedModal from '../../modals/GetStartedModal';

class GetStartedDropdownLink extends Component {
  handleClick = e => {
    const { toggleModal, link } = this.props;
    e.preventDefault();
    toggleModal(link);
  };

  render() {
    const { link } = this.props;
    return (
      <Link key={link.url} className="dropdown-item" onClick={this.handleClick}>
        {link.title}
      </Link>
    );
  }
}

class GetStartedDropdownButton extends Component {
  static propTypes = {
    routing: PropTypes.string,
    currentOrganizationId: PropTypes.string,
  };

  state = {
    showModal: false,
  };

  toggleModal = link => {
    this.setState({ showModal: !this.state.showModal });
    if (link) {
      this.setState({ link });
    }
  };

  buildDropdownList = () => {
    return [
      { title: 'Quick Start (62 sec)', url: 'https://vimeo.com/264471767' },
      {
        title: 'Using Work Breakdown Structure (58 sec)',
        url: 'https://vimeo.com/264492325',
      },
      {
        title: 'Using the Dependency Structure Matrix (90 sec)',
        url: 'https://vimeo.com/264601326',
      },
      {
        title: 'Tasks and the Dashboard (65 sec)',
        url: 'https://vimeo.com/264687000',
      },
    ].map(l => (
      <GetStartedDropdownLink
        key={l.link}
        link={l}
        toggleModal={this.toggleModal}
      />
    ));
  };

  render() {
    return (
      // <li className="nav-item nav-item-margin">
      <div style={{ marginLeft: 5 }}>
        <DropDownButton
          bClassName={'btn-btn-outline-secondary goto-dropdown'}
          title={'Get Started'}
          hideToggle={false}
        >
          {this.buildDropdownList()}
        </DropDownButton>
        <GetStartedModal
          showModal={this.state.showModal}
          handleCloseModal={this.toggleModal}
          contentLabel="Stuff"
          link={this.state.link}
        />
      </div>
      // </li>
    );
  }
}

export default GetStartedDropdownButton;



// WEBPACK FOOTER //
// ./src/components/buttons/GetStartedDropdownButton/GetStartedDropdownButton.js